import type { Lang } from "~/stores/locales/types";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useLocalesStore = defineStore("locales", () => {
  const locale: Ref<string> = ref<string>('ru');
  const { locale: i18locale } = useI18n();

  const localeCookie = useCookie('active-locale', {
    maxAge: 60 * 60 * 24 * 30,
    sameSite: 'lax',
    secure: false
  });

  function setLocale(lang: Lang): void
  {
    locale.value = lang;
    i18locale.value = lang;
    localeCookie.value = lang;
  }

  function initLocale () {
    const activeLocale: string = String(localeCookie.value) || 'ru';

    if (activeLocale !== 'ru' && activeLocale !== 'en') {
      setLocale('ru' as Lang);
      return;
    }

    setLocale(activeLocale as Lang);
  }

  return { locale, initLocale, setLocale };
});
